<template>
<div class="table-responsive">
	<GroupedMotions v-for="(row,index) in grouped_motions" :key="index" :grouped="row"></GroupedMotions>
	<div v-if="loading" class="alert alert-info" role="alert">
		{{ $t('loading_data') }}
	</div>
	<div v-if="!loading && !motions.length" class="alert alert-warning" role="alert">
		{{ $t('no_results') }}
	</div>


<!--	<tbody v-if="loading">
			<tr>
				<td colspan="100">{{ $t('loading_data') }}</td>
			</tr>
		</tbody>
		<tbody v-if="!loading && !motions.length">
			<tr>
				<td colspan="100">{{ $t('no_results') }}</td>
			</tr>
		</tbody>
	</table>
	-->
</div>
</template>

<script>
import GroupedMotions from '@/components/GroupedMotions';

export default {
	components: { GroupedMotions },
	props: ['motions','suppress_context','loading'],

	computed: {
		grouped_motions() {
			let grouped = {};
			let order = [];
			this.parsed_motions.forEach(row => {
				let key = (this.suppress_context) ? row.heading : row.heading + row.meeting_date + row.committee_name;
				if (key in grouped === false) {
					var obj = {};
					obj.title = (this.suppress_context) ? { title: row.heading } : { title: row.heading, meeting_date: row.meeting_date, committee: row.committee, committee_name: row.committee_name };
					obj.motions = [];
					order.push(key);
					grouped[key] = obj;
				}
				grouped[key].motions.push(row);
			});
			return order.map(key => grouped[key]);
		},
		
		parsed_motions() {
			let order = [];
			let parsed = {};
			this.motions.forEach(row => {

				if (row.motion_id in parsed === false) {
					var obj = {};
					['committee', 'meeting_date', 'agenda_id','motion_number','heading','title','result','yeas','nays','vote_rule', 'minutes_section_id', 'minutes_doc_id','committee_name', 'yea_percent', 'motion_id', 'vote_description'].forEach(element => {
						obj[element] = (element in row) ? row[element] : '';
					});
					obj['agenda_link'] = ('agenda_link' in row) ? row.agenda_link.url : '';
					obj.members = [];
					obj.yeah = [];
					obj.nay = [];
					obj.absent = [];
					obj.conflict = [];
					parsed[row.motion_id] = obj;
					order.push(row.motion_id);
				}
				if ('vote' in row) {
					parsed[row.motion_id].members.push(row.member);
					if (row.vote.toLowerCase() === 'yea') {
						parsed[row.motion_id].yeah.push(row.member);
					}
					if (row.vote.toLowerCase() === 'nay') {
						parsed[row.motion_id].nay.push(row.member);
					}
					if (row.vote.toLowerCase() === 'absent') {
						parsed[row.motion_id].absent.push(row.member);
					}
					if (row.vote.toLowerCase() === 'conflict of interest') {
						parsed[row.motion_id].conflict.push(row.member);
					}
				}
			})
			return order.map(motion_id => parsed[motion_id]);
		}
	},

}
</script>

<style>
tr.parsed-table td li {
	cursor: pointer;
}
tr.parsed-table th.order {
	cursor: pointer;
}
</style>

